import type { JSX } from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import type { ExperienceLevel } from '../../types/jobPosition.types';

const experienceLevelOptions: { value: ExperienceLevel; label: string }[] = [
  { value: 'ENTRY', label: 'Entry' },
  { value: 'JUNIOR', label: 'Junior' },
  { value: 'MID', label: 'Mid' },
  { value: 'SENIOR', label: 'Senior' },
  { value: 'LEAD', label: 'Lead' },
  { value: 'EXECUTIVE', label: 'Executive' },
];

interface ExperienceLevelCheckboxesProps {
  experienceLevels: ExperienceLevel[];
  onToggle: (level: ExperienceLevel) => void;
}

export function ExperienceLevelCheckboxes({
  experienceLevels,
  onToggle,
}: ExperienceLevelCheckboxesProps): JSX.Element {
  return (
    <div className="grid grid-cols-2 gap-3 rounded-md border p-3 sm:grid-cols-3">
      {experienceLevelOptions.map((option) => (
        <div key={option.value} className="flex items-center space-x-2">
          <Checkbox
            id={`exp-${option.value}`}
            checked={experienceLevels.includes(option.value)}
            onCheckedChange={() => onToggle(option.value)}
          />
          <label
            htmlFor={`exp-${option.value}`}
            className="cursor-pointer text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            {option.label}
          </label>
        </div>
      ))}
    </div>
  );
}
